import { render } from "./MobileBreadcrumbs.vue?vue&type=template&id=d5c6f334&scoped=true"
import script from "./MobileBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./MobileBreadcrumbs.vue?vue&type=script&lang=js"

import "./MobileBreadcrumbs.vue?vue&type=style&index=0&id=d5c6f334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c6f334"]])

export default __exports__